import { useIdleTimer } from "react-idle-timer";
import { useState, useCallback } from "react";

export const useSiderAutoCollapse = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuHover, setMenuHover] = useState(false);

  const handleMenuHover = useCallback((value: boolean) => {
    setMenuHover(value);
  }, []);

  const handleCollapse = useCallback((value: boolean) => {
    setCollapsed(value);
  }, []);

  const onSiderItemClick = useCallback(() => {
    setCollapsed(false);
  }, []);

  useIdleTimer({
    crossTab: false,
    leaderElection: false,
    timeout: 60000, // 1 minute
    onIdle: () => {
      setCollapsed(true);
    },
  });

  return {
    menuHover,
    collapsed,
    handleCollapse,
    handleMenuHover,
    onSiderItemClick,
  };
};
